import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, Gamepad2, CircleDot, Swords } from 'lucide-react';

const ICONS = { football_soccer: Trophy, tennis: CircleDot, cricket: Swords, esports: Gamepad2 };

export const MoreSportsStrip = ({ sports }) => (
  <section className="mt-16" data-testid="more-sports-section">
    <h2 className="text-base md:text-lg font-semibold text-white mb-1">More sports markets, refreshed every few hours</h2>
    <p className="text-sm text-gray-400 mb-5">Tennis, cricket and eSports matches open automatically and settle from the official result.</p>
    <div className="grid gap-3 grid-cols-2 lg:grid-cols-4">
      {sports.map((s) => {
        const Icon = ICONS[s.id] || Trophy;
        return (
          <Link
            key={s.id}
            to={s.id === 'football_soccer' ? '/?category=football_soccer' : `/sports/${s.id}`}
            data-testid={`more-sports-link-${s.id}`}
            className="group rounded-xl border border-[#1e2a45] bg-[#0d1424] p-4 hover:border-[#3B82F6]/50 hover:-translate-y-0.5 transition-[transform,border-color] duration-300"
          >
            <Icon className="h-5 w-5 text-[#3B82F6]" />
            <div className="mt-3 text-sm font-medium text-white">{s.name}</div>
            <div className="text-xs text-gray-500" data-testid={`more-sports-count-${s.id}`}>{s.open_markets} open markets</div>
          </Link>
        );
      })}
    </div>
  </section>
);

export default MoreSportsStrip;
